import { forEach, toggleClass, enableLinkTabbing, disableLinkTabbing } from '../functions';

export default function slats(){
  //find all expandable slats in the page
  var slats = document.querySelectorAll('.js-slat-group--expanding .slat');

  // if window is resized, the slat open height might need to be re-calculated.
  window.addEventListener("resize", function(){
    var activeContents = document.querySelectorAll('.slat--expanded .slat__content');
    [].forEach.call(activeContents, function (slatContents) {
      slatContents.style.maxHeight = (slatContents.scrollHeight) + "px";
    });
  });

  [].forEach.call(slats, function (slat) {
    var slatButton = slat.querySelector('.slat__header');

    //make all links within an expanded slat non-tabbable
    disableLinkTabbing(slat);

    slatButton.addEventListener('click', function () {
      var slatContents = slat.querySelector('.slat__content');

      if (slat.classList.contains('slat--expanded')) {
        //collapses expanded slat
        slat.classList.remove('slat--expanded');
          slatContents.style.maxHeight = null;
        disableLinkTabbing(slat); //makes the links within the now closed slat non-tabbable
      }
        else
      {
        //expands collapsed slat
        slat.classList.toggle('slat--expanded');
        slatContents.style.maxHeight = (slatContents.scrollHeight) + "px";
        enableLinkTabbing(slat); //make the links in the now open slat tabbable
      }
    });
  });

  var linkedSlats = document.querySelectorAll('.slat-group:not(.js-slat-group--expanding)');
  [].forEach.call(linkedSlats, function(slat) {
    var slatHeader = slat.querySelector('.slat__header');
    var slatButton = slat.querySelector('.slat__button');
    slatHeader.addEventListener('click', function () {
      slatButton.click();
    });
  })
}
